import { Navigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";

const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    //console.log("🔹 RoleBasedRoute - User Updated:", user);
  }, [user]);

  if (!user) {
    console.warn("🚨 No user found, redirecting to login.");
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    console.warn(`🚨 Unauthorized: Needed one of ${allowedRoles.join(", ")}, got ${user.role}`);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RoleBasedRoute;